export function calculateAccident(data) {
    return axios({
        url: '/api/' + process.env.VUE_APP_SERVER_MODE + '/insurance/calculator/accident',
        method: 'post',
        data
    })
}
